import OwnerCard from './OwnerCard'

export default OwnerCard
